export default __webpack_public_path__ + "static/media/about-mission.0b2c7d29.svg";